import { render, staticRenderFns } from "./NagsCatalog.vue?vue&type=template&id=680c58d5&scoped=true"
import script from "./NagsCatalog.vue?vue&type=script&lang=js"
export * from "./NagsCatalog.vue?vue&type=script&lang=js"
import style0 from "./NagsCatalog.vue?vue&type=style&index=0&id=680c58d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c58d5",
  null
  
)

export default component.exports